import axios from 'axios';

import router from '../router/index.js';

let switchX = true;

// 正式环境
axios.defaults.baseURL = 'https://dqappv2.diqwl.com/';
const apiBaseUrl = 'https://dqappv2.diqwl.com/';

//测试环境
// axios.defaults.baseURL = 'http://dqtest.diqwl.com';
// const apiBaseUrl = 'https://dqtest.diqwl.com/'  //张泽辉

//dev 服务器环境
// axios.defaults.baseURL = 'http://120.77.87.96:8081';
// const apiBaseUrl = 'http://120.77.87.96:8081/';


//开发环境
// axios.defaults.baseURL = 'http://localhost:8080';
// const apiBaseUrl = 'http://localhost:8080/';


const postRequest = (url, data , callback,error)=>{
	// 调试模式，打印请求信息
	console.log(url + '参数：')
	console.log(paramWithClientInfo(data))
	console.log(localStorage.getItem('accessToken'))
	
    axios({
	  method: 'post',
	  url: apiBaseUrl + url,
	  data: paramWithClientInfo(data),
	  headers: {
	  	'Content-Type': 'application/json',
	  	'token': localStorage.getItem('accessToken'),
		"authCode":'GJaImrLgzbgKQ0GaNX5kgCDtPrk7mcdF6Kq2zxe62pU=',
		"appId":'hcbHiywpFpP3m8CTW0',
		"device": 'admin'
	  }
    }).then(res => {
		// if(res.data.status == 401){
		// 	//登录成功后跳转到指定页面
		// 	//router.push('/');
		// 	if(switchX){
		// 		switchX = false;
		// 		alert("登录状态过期或已在其他设备登录！~")
		// 		let href = window.location.href;
		// 		window.location.href = href.substring(0,href.indexOf('/#'))
		// 	}
		// 	return;
		// }
		switchX = true;
		console.log(url + '结果：')
		console.log(res)
		callback(res);
	});
}

/**
 * 请求参数包含客户端信息
 */
function paramWithClientInfo(param) {
  const data = JSON.stringify({
    param: param,
	appType: 'storeAdmin',
	appVersion: '2.0.0',
	uuid: "1",
	system: 'storeAdmin',
	brand: 'storeAdmin',
	model: 'storeAdmin',
	systemVersion: 'storeAdmin',
	apiVersion: '2.0.0',
	platform: 'storeAdmin',
	nonce: '5'
  })
  return data;
}


export default{
	apiBaseUrl,
	postRequest
}